import { useState, useEffect } from 'react'

export default function AnalogClock({ size = 120, className = '', showIndicators = true }: { size?: number; className?: string; showIndicators?: boolean }) {
  const [time, setTime] = useState(new Date())

  useEffect(() => {
    const timer = setInterval(() => {
      setTime(new Date())
    }, 1000)
    return () => clearInterval(timer)
  }, [])

  const seconds = time.getSeconds()
  const minutes = time.getMinutes()
  const hours = time.getHours()

  const secondDegrees = (seconds / 60) * 360
  const minuteDegrees = ((minutes + seconds / 60) / 60) * 360
  const hourDegrees = (((hours % 12) + minutes / 60) / 12) * 360

  return (
    <div 
      className={`relative rounded-full bg-slate-900/60 border-2 border-slate-700/50 shadow-xl backdrop-blur-md transition-all duration-500 ease-out hover:scale-[1.8] hover:bg-slate-800/80 hover:border-primary-500/30 hover:shadow-primary-500/20 z-10 ${className}`}
      style={{ width: size, height: size }}
    >
      {/* Clock Center Dot */}
      <div 
        className="absolute top-1/2 left-1/2 bg-primary-500 rounded-full -translate-x-1/2 -translate-y-1/2 z-20 shadow-sm border border-white/20" 
        style={{ width: size * 0.08, height: size * 0.08 }}
      />

      {/* Clock Face Indicators */}
      {showIndicators && [...Array(12)].map((_, i) => (
        <div
          key={i}
          className="absolute bg-slate-500/50 left-1/2 -translate-x-1/2"
          style={{ 
            width: size * 0.02,
            height: size * 0.08,
            top: size * 0.02,
            transform: `rotate(${i * 30}deg)`,
            transformOrigin: `50% ${size / 2 - size * 0.02}px`
          }}
        />
      ))}

      {/* Hour Hand */}
      <div 
        className="absolute bottom-1/2 left-1/2 bg-slate-200 rounded-full origin-bottom -translate-x-1/2 transition-transform duration-500"
        style={{ 
          width: size * 0.04,
          height: '25%',
          transform: `rotate(${hourDegrees}deg)` 
        }}
      />

      {/* Minute Hand */}
      <div 
        className="absolute bottom-1/2 left-1/2 bg-slate-400 rounded-full origin-bottom -translate-x-1/2 transition-transform duration-500"
        style={{ 
          width: size * 0.03,
          height: '35%',
          transform: `rotate(${minuteDegrees}deg)` 
        }}
      />

      {/* Second Hand */}
      <div 
        className="absolute bottom-1/2 left-1/2 bg-primary-500 rounded-full origin-bottom -translate-x-1/2 transition-transform duration-100"
        style={{ 
          width: size * 0.015,
          height: '42%',
          transform: `rotate(${secondDegrees}deg)` 
        }}
      />
      
      {/* Internal Glass Shine */}
      <div className="absolute inset-0 rounded-full bg-gradient-to-tr from-white/10 to-transparent pointer-events-none" />
    </div>
  )
}
